// „Termine“ (Screen mieter/04): vom Büro freigegebene Termine (eigene und hausweite) und Termine zu
// eigenen Meldungen. „In meinen Kalender“ erzeugt die Kalenderdatei im Browser – nichts wird verschickt.
import { CalendarBlank, CalendarPlus, ChatCircleDots, Info } from '@phosphor-icons/react';
import { LeerZustand, SeitenTitel, farbKlasse, type PortalFarbe } from '../../components/portal/bausteine';
import { icsDateiname, icsInhalt, terminBlatt, terminTyp, terminZeit, type PortalTermin } from '../../lib/portal/mieterE5';

export const terminFarbe = (t: PortalTermin): PortalFarbe => (t.ticket_nummer ? 'heizung' : 'schluessel');

export function kalenderDatei(t: PortalTermin, ort: string) {
  const blob = new Blob([icsInhalt(t, ort)], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = icsDateiname(t);
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}

export function TerminKarte({ t, ort, onMeldung }: { t: PortalTermin; ort: string; onMeldung: () => void }) {
  const b = terminBlatt(t.start_datum);
  const farbe = terminFarbe(t);
  return (
    <article className={`p-glas p-hebt ${farbKlasse(farbe)}`} style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div className="p-glas-schimmer"><CalendarBlank size={160} weight="duotone" className="p-wasserzeichen" style={{ opacity: 0.11 }} /></div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <span style={{ width: 62, flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '8px 0', borderRadius: 16, background: 'var(--p-w08)', boxShadow: 'inset 0 1px 0 var(--p-w08)' }}>
          <span style={{ fontSize: 11, fontWeight: 800, color: 'var(--c1)', textTransform: 'uppercase' }}>{b.monat}</span>
          <span style={{ fontSize: 26, fontWeight: 800, lineHeight: 1.05 }}>{b.tag}</span>
          <span style={{ fontSize: 10.5, fontWeight: 700, color: 'var(--p-w45)' }}>{b.wochentag}</span>
        </span>
        <span style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 3 }}>
          <span style={{ fontSize: 11, fontWeight: 800, color: 'var(--c1)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{terminTyp(t)}</span>
          <span style={{ fontSize: 16.5, fontWeight: 800, overflowWrap: 'anywhere' }}>{t.titel || terminTyp(t)}</span>
          <span style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--p-w55)' }}>{[terminZeit(t), t.firma].filter(Boolean).join(' · ')}</span>
        </span>
      </div>
      {t.hinweis && (
        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start', padding: '10px 12px', borderRadius: 14, background: 'rgba(var(--rgb),0.12)', fontSize: 12.5, fontWeight: 600, lineHeight: 1.4, color: 'var(--p-w85)' }}>
          <Info size={15} weight="fill" style={{ marginTop: 1, color: 'var(--c1)' }} />{t.hinweis}
        </div>
      )}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <button type="button" className="p-knopf" onClick={() => kalenderDatei(t, ort)} data-tip="Termin als Kalenderdatei speichern" style={{ height: 40, border: 'none', background: 'var(--p-w08)', fontSize: 13 }}>
          <CalendarPlus size={16} /> In meinen Kalender
        </button>
        {t.ticket_nummer && (
          <button type="button" className="p-knopf" onClick={onMeldung} data-tip="Zur Meldung, zu der dieser Termin gehört" style={{ height: 40, border: 'none', background: 'var(--p-w08)', fontSize: 13 }}>
            <ChatCircleDots size={16} /> Meldung {t.ticket_nummer}
          </button>
        )}
      </div>
    </article>
  );
}

export default function MieterTermine({ termine, ort, onMeldung }: { termine: PortalTermin[]; ort: string; onMeldung: () => void }) {
  return (
    <div className="p-rein" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <SeitenTitel oben="In Ihrer Wohnung und im Haus" titel="Termine" />
      {termine.length === 0
        ? <LeerZustand icon={CalendarBlank} text="Zurzeit sind keine Termine geplant" />
        : <div className="mp-karten">{termine.map((t) => <TerminKarte key={t.id} t={t} ort={ort} onMeldung={onMeldung} />)}</div>}
    </div>
  );
}
